import React, { FC, ReactNode, useEffect } from 'react';
import { useRouter } from 'next/router';
import { styled } from 'linaria/react';
import { SearchPayee } from '@entities/tsp';
import { withTheme } from '@shared/lib/theme';
import { useModal } from '@shared/lib';
import { homeSearchClickGtm } from '@shared/lib/gtm/redesign';
import { useWindowScrollPosition } from '@shared/lib/browser';
import { ModalProps } from '@shared/ui/organisms';
import { SearchIcon } from '@shared/assets/icons';
import SearchModalMobile from './SearchModalMobile';
type SuggestModalProps = ModalProps;
interface SearchButtonProps {
  servicesForSearch?: SearchPayee[];
  renderSuggestModal: (props: SuggestModalProps) => ReactNode;
}
const SearchButton: FC<SearchButtonProps> = ({
  servicesForSearch,
  renderSuggestModal
}) => {
  const router = useRouter();
  const isAtTop = useWindowScrollPosition();
  const {
    isModalActive,
    handleModalClose,
    handleModalOpen
  } = useModal();
  useEffect(() => {
    handleModalClose();
  }, [router.asPath]);
  return <>
      <SearchButtonWrapper type="button" aria-label="Поиск" isAtTop={isAtTop} onClick={() => {
      homeSearchClickGtm();
      handleModalOpen();
    }}>
        <SearchIcon />
      </SearchButtonWrapper>
      <SearchModalMobile open={isModalActive} onClose={handleModalClose} servicesForSearch={servicesForSearch} renderSuggestModal={renderSuggestModal} />
    </>;
};
export default SearchButton;
interface SearchButtonWrapperProps {
  isAtTop: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isAtTop,
  theme
}) => isAtTop ? theme.colors.constant.white : theme.colors.icon.primary;
const SearchButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "SearchButtonWrapper",
  class: "s1uz093x",
  propsAsIs: false,
  vars: {
    "s1uz093x-0": [_exp()]
  }
}));

require("./SearchButton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SearchButton.tsx");